import { useMemo } from 'react';
import { uniqBy } from 'lodash';

import { FilterType } from '../constants';
import { getTimestampByPeriod } from '../utils/timePeriod';

export function useFilteredWells(wells, filters) {
  const sideTrackStrRegex = /\sST0/g;

  return useMemo(() => {
    if (!wells) return null;

    let filteredWells = wells.filter(well =>
      Object.keys(filters).every(filterKey => {
        if (typeof filters[filterKey] !== 'object') return true;
        if (filters[filterKey].length > 0 && !filters[filterKey].includes(well[filterKey])) {
          return false;
        }
        return true;
      })
    );

    if (typeof filters[FilterType.sideTracks] !== 'undefined') {
      filteredWells = filteredWells.filter(
        well => !filters[FilterType.sideTracks] || !well.name.match(sideTrackStrRegex)
      );
    }

    const { period, timeRangeFrom, timeRangeTo } = filters;
    const [startTimestamp, endTimestamp] = getTimestampByPeriod(period, timeRangeFrom, timeRangeTo);

    if (Number.isFinite(startTimestamp) && Number.isFinite(endTimestamp)) {
      filteredWells = filteredWells.filter(
        well => well.lastActive >= startTimestamp && well.lastActive <= endTimestamp
      );
    }

    // Radius filter
    if (Number.isFinite(filters.radius)) {
      filteredWells = filteredWells.filter(well => well.distance <= filters.radius);
    }

    return uniqBy(filteredWells, 'id');
  }, [wells, filters]);
}
